import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LanguageEntry } from 'types/types'

interface AppState {
  totalPoints: number
  shownLanguages: string[]
  totalRounds: number
  currentRound: LanguageEntry
  nextRound: LanguageEntry
}

const initialState: AppState = {
  totalPoints: 0,
  shownLanguages: [],
  totalRounds: 0,
  currentRound: {
    code: '',
    language: '',
    all_countries: [],
    common_country: '',
    lat: 0,
    long: 0,
    audioPath: '',
    level: 0,
  },
  nextRound: {
    code: '',
    language: '',
    all_countries: [],
    common_country: '',
    lat: 0,
    long: 0,
    audioPath: '',
    level: 0,
  },
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    addPoints: (state, action: PayloadAction<number>) => {
      state.totalPoints += action.payload
    },
    addShownLanguage: (state, action: PayloadAction<string>) => {
      state.shownLanguages.push(action.payload)
    },
    addRound: (state) => {
      state.totalRounds += 1
    },
    resetGame: (state) => {
      state.totalPoints = 0
      state.totalRounds = 0
    },
    removeRound: (state) => {
      state.totalRounds -= 1
    },
    removePoints: (state, action: PayloadAction<number>) => {
      state.totalPoints -= action.payload
    },
    addCurrentRoundDetails: (state, action: PayloadAction<LanguageEntry>) => {
      state.currentRound = action.payload
    },
    addNextRoundDetails: (state, action: PayloadAction<LanguageEntry>) => {
      state.nextRound = action.payload
    },
  },
})

export const {
  addPoints,
  addShownLanguage,
  addRound,
  resetGame,
  removeRound,
  removePoints,
  addCurrentRoundDetails,
  addNextRoundDetails,
} = appSlice.actions
export default appSlice.reducer
